import React from 'react'

export const Asterisk = () => (
  <span className="text-red-star text-h3 font-medium leading-5 ">*</span>
)
